import { WinsPage } from './WinsPage';

export function EnrolmentMethodPage() {
  return (
    <WinsPage
      trainingTypeOverride="new-model-enrolment-method"
      trainingLabelOverride="New Model of NLP Enrolment Method Training"
      trainingDays={[1]}
      heading="What was your win from Day 1?"
      description="Take a moment to reflect on today's training. Share your biggest insight, breakthrough, or moment of clarity — we read every single one."
    />
  );
}
